const debounce = (callback, wait) => {
    let timerId = null;
    const debounced = (...args) => {
        const { setTimeout, clearTimeout } = window;
        if (timerId) {
            clearTimeout(timerId);
        }
        timerId = setTimeout(() => {
            callback(...args);
            if (!timerId) {
                return;
            }
            clearTimeout(timerId);
        }, wait);
    };
    return debounced;
};

export { debounce };
//# sourceMappingURL=index.js.map
